import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import {
    SEND_OPERATIONS_CLEAR_STATE,
    SEND_OPERATIONS_FAILURE,
    SEND_OPERATIONS_REQUESTED,
    SEND_OPERATIONS_SUCCESS,
} from "./actions"
import {
    FETCH_ACCESS_AND_ROLES_SUCCESS,
    FETCH_ACCOUNT_IMAGES_SUCCESS,
    FETCH_CUSTOMER_DETAIL_SUCCESS,
    FETCH_DEPARTMENTS_SUCCESS,
    FETCH_INVENTORY_ITEMS_SUCCESS,
    FETCH_LOYALTY_PROGRAM_SUCCESS,
    FETCH_ROLES_SUCCESS,
    FETCH_USER_ACCOUNTS_SUCCESS,
    SAVE_ACCOUNT_IMAGES_SUCCESS,
} from "../../api/actions"
import { OperationType } from "../../api/types"
import { USER_VERSION_UPDATED } from "../screens/employees/employees/actions"
import { LOCATION_CREATED, LOCATION_UPDATED } from "../data/actions"
import {
    SAVE_LOCATION_FAILURE,
    SAVE_LOCATION_SUCCESS,
    SAVE_TERMINAL_FAILURE,
    SAVE_TERMINAL_SUCCESS,
} from "../screens/locations/actions"
import {
    OPTION_GROUP_LOCATION_SAVE_FAILURE,
    OPTION_GROUP_LOCATION_SAVE_REQUESTED,
    OPTION_GROUP_LOCATION_SAVE_SUCCESS,
    OPTION_GROUP_SAVE_FAILURE,
    OPTION_GROUP_SAVE_REQUESTED,
    OPTION_GROUP_SAVE_SUCCESS,
} from "../screens/categories/optionGroups/actions"
import {
    MODIFIER_GROUP_LOCATION_SAVE_FAILURE,
    MODIFIER_GROUP_LOCATION_SAVE_SUCCESS,
} from "../screens/categories/modifierGroups/actions"
import {
    MODIFIER_LOCATION_SAVE_FAILURE,
    MODIFIER_LOCATION_SAVE_REQUESTED,
    MODIFIER_LOCATION_SAVE_SUCCESS,
    MODIFIER_SAVE_FAILURE,
    MODIFIER_SAVE_REQUESTED,
    MODIFIER_SAVE_SUCCESS,
} from "../screens/categories/modifiers/actions"
import {
    PRICING_LOCATION_SAVE_FAILURE,
    PRICING_LOCATION_SAVE_REQUESTED,
    PRICING_LOCATION_SAVE_SUCCESS,
    PRICING_SAVE_FAILURE,
    PRICING_SAVE_REQUESTED,
    PRICING_SAVE_SUCCESS,
} from "../screens/pricingsAndPromotions/pricing/actions"
import {
    DELIVERY_FEE_FORM_SUBMITTED_V2,
    DELIVERY_FEE_FORM_SUBMITTED_V2_SUCCESS,
} from "../screens/settings/deliverySettings/actions"
import { FETCH_SCHEMATIZED_FAILURE, SCHEMATIZED_SAVE_FAILURE } from "../screens/salesInput/schematized/actions"

export type ObjectOfVersions = Record<string, number>

export type OperationsState = {
    versions: ObjectOfVersions
    state: string
}

export const createDefaultOperationsState = () => ({
    versions: {},
    state: "ready",
})
export const operationsReducer = (operationState: Maybe<OperationsState> = undefined, action: Record<string, any>) => {
    if (!operationState) {
        return createDefaultOperationsState()
    }

    switch (action.type) {
        // TODO later get rid of operations in this reducer, it would be only for saving indicator
        case DELIVERY_FEE_FORM_SUBMITTED_V2:
        case PRICING_SAVE_REQUESTED:
        case PRICING_LOCATION_SAVE_REQUESTED:
        case LOCATION_CREATED:
        case LOCATION_UPDATED:
        case MODIFIER_SAVE_REQUESTED:
        case MODIFIER_LOCATION_SAVE_REQUESTED:
        case OPTION_GROUP_SAVE_REQUESTED:
        case OPTION_GROUP_LOCATION_SAVE_REQUESTED:
        case SEND_OPERATIONS_REQUESTED: {
            return { ...operationState, state: "processing" }
        }

        case DELIVERY_FEE_FORM_SUBMITTED_V2_SUCCESS:
        case PRICING_SAVE_SUCCESS:
        case PRICING_LOCATION_SAVE_SUCCESS:
        case MODIFIER_SAVE_SUCCESS:
        case MODIFIER_LOCATION_SAVE_SUCCESS:
        case MODIFIER_GROUP_LOCATION_SAVE_SUCCESS:
        case OPTION_GROUP_SAVE_SUCCESS:
        case OPTION_GROUP_LOCATION_SAVE_SUCCESS:
        case SAVE_LOCATION_SUCCESS:
        case SAVE_TERMINAL_SUCCESS:

        case PRICING_SAVE_FAILURE:
        case PRICING_LOCATION_SAVE_FAILURE:
        case MODIFIER_SAVE_FAILURE:
        case MODIFIER_LOCATION_SAVE_FAILURE:
        case MODIFIER_GROUP_LOCATION_SAVE_FAILURE:
        case OPTION_GROUP_SAVE_FAILURE:
        case OPTION_GROUP_LOCATION_SAVE_FAILURE:
        case SCHEMATIZED_SAVE_FAILURE:
        case SAVE_LOCATION_FAILURE:
        case SAVE_TERMINAL_FAILURE:
        case FETCH_SCHEMATIZED_FAILURE: {
            return { ...operationState, state: "failure" }
        }

        case SEND_OPERATIONS_SUCCESS: {
            const newVersions = Object.assign({}, operationState.versions)
            action.payload.operations.forEach(op => {
                if (op.type === OperationType.Update) {
                    newVersions[op.record_id] = op.record_version + 1
                } else if (op.type === OperationType.Insert) {
                    newVersions[op.record_id] = op.record_version
                } else if (op.type === OperationType.Delete) {
                    delete newVersions[op.record_id]
                }
            })
            return { ...operationState, state: "success", versions: newVersions }
        }

        case SEND_OPERATIONS_FAILURE:
            return { ...operationState, state: "failure" }

        case SEND_OPERATIONS_CLEAR_STATE:
            return { ...operationState, state: "ready" }

        case FETCH_CUSTOMER_DETAIL_SUCCESS:
        case FETCH_USER_ACCOUNTS_SUCCESS:
        case FETCH_ACCESS_AND_ROLES_SUCCESS:
        case FETCH_ROLES_SUCCESS:
        case FETCH_DEPARTMENTS_SUCCESS:
        case FETCH_LOYALTY_PROGRAM_SUCCESS:
        case FETCH_INVENTORY_ITEMS_SUCCESS:
        case FETCH_ACCOUNT_IMAGES_SUCCESS:
        case SAVE_ACCOUNT_IMAGES_SUCCESS:
        case USER_VERSION_UPDATED:
            return { ...operationState, versions: { ...operationState.versions, ...action.payload.versions } }

        default:
            return operationState
    }
}
